import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainSidebar = _resolveComponent("MainSidebar")!
  const _component_MainHeader = _resolveComponent("MainHeader")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_SuccessSnackbar = _resolveComponent("SuccessSnackbar")!
  const _component_LoadingDialog = _resolveComponent("LoadingDialog")!
  const _component_AlertComponent = _resolveComponent("AlertComponent")!
  const _component_PaymentRequiredModal = _resolveComponent("PaymentRequiredModal")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['bf-shell', { 'bf-shell--auth': !_ctx.shouldShowSidebar }])
  }, [
    (_ctx.shouldShowSidebar)
      ? (_openBlock(), _createBlock(_component_MainSidebar, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.shouldShowSidebar && _ctx.stateStoreInstance.open)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "bf-backdrop",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args)))
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass([
        'main-content d-flex flex-column',
        { 'with-sidebar': _ctx.shouldShowSidebar },
      ])
    }, [
      (_ctx.shouldShowHeader)
        ? (_openBlock(), _createBlock(_component_MainHeader, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(_component_router_view),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "flex-grow-1" }, null, -1))
    ], 2),
    _createVNode(_component_SuccessSnackbar),
    _createVNode(_component_LoadingDialog),
    (_ctx.alertStoreInstance.isVisible)
      ? (_openBlock(), _createBlock(_component_AlertComponent, {
          key: 2,
          style: {"position":"fixed","right":"15px","bottom":"0px"},
          message: _ctx.alertStoreInstance.message,
          type: _ctx.alertStoreInstance.type,
          onCloseAlert: _cache[1] || (_cache[1] = 
        () => (_ctx.alertStoreInstance.isVisible = !_ctx.alertStoreInstance.isVisible)
      )
        }, null, 8, ["message", "type"]))
      : _createCommentVNode("", true),
    _createVNode(_component_PaymentRequiredModal)
  ], 2))
}